<template>
    <div class="insight-data-landing-page">
      <div class="loading-spinner-outer" v-if="sending">
        <div class="loading-spinner-inner">
          <div class="loading-spinner"></div>
          <div class="loading-spinner-content">
            Sending, please wait
          </div>
        </div>
      </div>
        <div class="landing-page-introduction-box">
            <div class="title">
                <div>
                   Email Marketing in partnership with Insight Data
                </div>
                <div class="logo">
                    <img src="/images/insight-data-logo-small.png">
                </div>
            </div>
            <div class="box-1">
                <h1>Receive 5% discount on 3 month campaigns, 10% for 6 month, 20% for 12 months.</h1>
              <p>
                Email marketing has become the most powerful way of generating new business, maintaining existing customer relations and building awareness. It gets delivered directly to the inbox of key decision-makers, bypassing the traditional ‘gatekeeper’. With more and more people accessing email on their mobile phone, it’s more effective than ever before.
              </p>
              <p>
                Insight Data has a specialist in house division with an email, design and technical team that can send out professional emails to your customers and prospects. Your campaign can link to your website or a dedicated landing page with a lead capture form using the Insight database.
              </p>
            </div>
            <div class="overlapping-image">
                <img src="/images/offers-and-promotions-email-marketing-header.png">
            </div>
            <div class="box-2">
                <p>
                  Receive 5% discount on 3 month campaigns, 10% for 6 month, 20% for 12 months.
                </p>
                <p>
                    <a class="btn-primary-outline _lg" @click.prevent="enquiry_box_open = true">
                        Make Enquiry
                    </a>
                </p>
            </div>
        </div>
        <div class="modal-window" :class="{'open': enquiry_box_open}" @click="enquiry_box_open = false">
            <div class="modal-window-inner" @click.stop>
                <div class="modal-close" @click.stop="enquiry_box_open = false">
                    <i class="fal fa-times"></i>
                </div>
                <div class="modal-header">
                    <h1 class="modal-title">Email Marketing Enquiry</h1>
                </div>
                <div class="modal-content">
                    <div class="form-group">
                        Please enter details of your enquiry below.
                    </div>
                    <textarea rows="5" v-model="enquiry_message" class="form-control"></textarea>
                </div>
                <div class="modal-footer align-right">
                    <a class="btn-primary" @click="sendEnquiry()">
                        Send
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: [
        'logged_in_user',
    ],
    data() {
        return {
            'enquiry_box_open': false,
            'enquiry_message': 'I would like some more information on Email Marketing',
          sending: false,
        }
    },
    methods: {
        sendEnquiry() {
          this.enquiry_box_open = false;
          this.sending = true;
            axios.post('/enquiry/send', {
                'enquiry_type_id': 33,
                'message': this.enquiry_message,
            }).then((response) => {

              gtag('event', 'enquiry_made', {
                'event_category': 'enquiries',
                'event_label': 'Email Marketing enquiry',
                'value': 'Email Marketing enquiry',
              });

              this.sending = false;
                Swal.fire({
                    title: 'Enquiry Sent',
                    icon: 'success',
                    text: 'Your enquiry has been sent, you will be sent a notification when you receive a reply.'
                });
            });
        },
      partnerLinkClicked() {
        axios.post('/activity-logs/createActivityLogFromRequest', {
          'activity_log_category_id': 3,
          'description': `Partner Link Clicked - Epwin Marketing`,
        });
        gtag('event', 'partner_link_clicked', {
          'event_category': 'link',
          'event_label': 'Email Marketing partner link clicked',
          'value': 'Email Marketing partner link clicked',
        });
      },
    },
};
</script>
